import { apiRequest } from '../../services/apiClient';

// 회사소개 > 협력사 페이지에 노출되는 협력사. 관리자 콘솔(/admin/partners)에서 관리한다
export interface Partner {
  id: number;
  name: string;
  field: string | null;
  url: string | null;
  logoUrl: string | null;
  createdAt: string;
}

export interface AdminPartner extends Partner {
  sortOrder: number;
  isPublished: boolean;
}

export interface PartnerInput {
  name: string;
  field: string;
  url: string;
  isPublished: boolean;
}

export function fetchPartners(): Promise<Partner[]> {
  return apiRequest<Partner[]>('/api/partners');
}
